module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/is-object.js